import * as React from "react";

const ProductLogo2 = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1080 1080"
        width={60}
        height={60}
        className="cos-home-product-logo"
        {...props}
    >
        <defs>
            <style>
                {
                    ".ami-logo-color_svg__cls-2{fill:#8256e7}.ami-logo-color_svg__cls-3{fill:#b49af0}"
                }
            </style>
        </defs>
        <g
            style={{
                isolation: "isolate",
            }}
        >
            <g id="ami-logo-color_svg__Layer_1" data-name="Layer 1">
                <path
                    className="ami-logo-color_svg__cls-2"
                    d="M830.85 902.13 187.52 585.72l76.54-174.6 650.56 320A95.23 95.23 0 0 1 960 854.83a95.24 95.24 0 0 1-129.15 47.3Z"
                />
                <path
                    className="ami-logo-color_svg__cls-2"
                    d="m513 306.29 274.79 553.35A95.22 95.22 0 0 0 912 903.37a95.22 95.22 0 0 0 45.7-129.79L683 220.51a95.23 95.23 0 0 0-124.29-43.88A95.24 95.24 0 0 0 513 306.29Z"
                />
                <path
                    className="ami-logo-color_svg__cls-2"
                    d="M693.07 263.47a94.6 94.6 0 0 1-10.25 42.81L439 797.18l-170.9-84.06L512.75 220.5a95.27 95.27 0 0 1 180.32 43Z"
                />
                <path
                    className="ami-logo-color_svg__cls-3"
                    d="m264.06 411.12-144.2 32.23a9.81 9.81 0 0 0-6.45 14.65l74.11 127.72Z"
                />
                <path
                    d="m151.35 436.74-21.49 48.79L113.41 458a9.78 9.78 0 0 1 6.44-14.62Z"
                    style={{
                        opacity: 0.25,
                        fill: "#231f20",
                        mixBlendMode: "multiply",
                    }}
                />
                <path
                    className="ami-logo-color_svg__cls-3"
                    d="m439 797.18-31 62.47a95.24 95.24 0 1 1-169.92-86.08l30-60.45Z"
                />
                <path
                    d="m399.79 447.95-11.92 24.06 170.9 84.04-158.98-108.1zm241.96 117.66 229.35 144.6-208.86-103.26-20.49-41.34zm-43.86-88.29 88.3-173.58-72.6 205.17-15.7-31.59z"
                    style={{
                        fill: "#231f20",
                        mixBlendMode: "multiply",
                        opacity: 0.2,
                    }}
                />
            </g>
        </g>
    </svg>
);

export default ProductLogo2;
